import { saveCart } from "../helpers";

export const CART_ACTIONS = {
  ADD_INSERT: "add_insert",
  EDIT_INSERT: "edit_insert",
  REMOVE_INSERT: "remove_insert",
  INCREASE_QUANTITY: "increase_quantity",
  DECREASE_QUANTITY: "decrease_quantity",
  INITIALIZE_CART: "initialize_cart",
};

const isBrowser = typeof window !== "undefined";

// action handlers

const addInsertToCart = (insert, state) => {
  const updatedCart = [...state.cart];
  const updatedInsertIndex = updatedCart.findIndex(
    (item) => item.id === insert.id
  );

  if (updatedInsertIndex < 0) {
    if (insert.quantity <= 1) {
      updatedCart.push({ ...insert, quantity: 1 });
    } else {
      updatedCart.push({ ...insert, quantity: insert.quantity });
    }
  } else {
    const updatedInsert = {
      ...updatedCart[updatedInsertIndex],
    };
    updatedInsert.quantity = updatedInsert.quantity + insert.quantity;
    updatedCart[updatedInsertIndex] = updatedInsert;
  }
  const returnState = { ...state, cart: updatedCart };
  saveCart(returnState.cart);
  return returnState;
};

const editInsert = (insert, state) => {
  const updatedCart = [...state.cart];
  const updatedInsertIndex = updatedCart.findIndex(
    (item) => item.id === insert.id
  );

  if (updatedInsertIndex < 0) {
    return state;
  } else {
    updatedCart[updatedInsertIndex] = insert;
  }
  const returnState = { ...state, cart: updatedCart };
  saveCart(returnState.cart);
  return returnState;
};

const removeInsertFromCart = (insert, state) => {
  const updatedCart = [...state.cart];
  const updatedInsertIndex = updatedCart.findIndex(
    (item) => item.id === insert.id
  );
  updatedCart.splice(updatedInsertIndex, 1);
  const returnState = { ...state, cart: updatedCart };
  saveCart(returnState.cart);
  return returnState;
};

const increaseInsertQuantity = (insert, quantity, state) => {
  const updatedCart = [...state.cart];
  const updatedInsertIndex = updatedCart.findIndex(
    (item) => item.id === insert.id
  );
  const updatedInsert = {
    ...updatedCart[updatedInsertIndex],
  };
  updatedInsert.quantity = updatedInsert.quantity + quantity;
  updatedCart[updatedInsertIndex] = updatedInsert;

  const returnState = { ...state, cart: updatedCart };
  saveCart(returnState.cart);
  return returnState;
};

const decreaseInsertQuantity = (insert, state) => {
  const updatedCart = [...state.cart];
  const updatedInsertIndex = updatedCart.findIndex(
    (item) => item.id === insert.id
  );
  const updatedInsert = {
    ...updatedCart[updatedInsertIndex],
  };
  if (updatedInsert.quantity - 1 <= 0) {
    updatedInsert.quantity = 1;
  } else updatedInsert.quantity--;
  updatedCart[updatedInsertIndex] = updatedInsert;

  const returnState = { ...state, cart: updatedCart };
  saveCart(returnState.cart);
  return returnState;
};

export const cartReducer = (state, action) => {
  switch (action.type) {
    case CART_ACTIONS.ADD_INSERT:
      return addInsertToCart(action.insert, state);
    case CART_ACTIONS.EDIT_INSERT:
      return editInsert(action.insert, state);
    case CART_ACTIONS.REMOVE_INSERT:
      return removeInsertFromCart(action.insert, state);
    case CART_ACTIONS.INCREASE_QUANTITY:
      return increaseInsertQuantity(action.insert, action.quantity, state);
    case CART_ACTIONS.DECREASE_QUANTITY:
      return decreaseInsertQuantity(action.insert, state);
    case CART_ACTIONS.INITIALIZE_CART:
      return action.value;
    default:
      return state;
  }
};
